<script lang="ts">
import { type Message, MessageContentType, RatingTarget } from '@smartsupp/smartsupp-message'
import { RatingTarget as WsRatingTarget } from '@smartsupp/websocket-client-visitor'

import { testIds } from '@/constants'
import Button from '@/core/Button.svelte'
import { suggestedRating } from '@/modules/chat'
import {
	type ChatRatingInfo,
	chatRatingInfoMap,
	getChatRatingImageUrl,
	openChatRatingDrawer,
	ratingInfoArray,
} from '@/modules/chatRating'
import { t } from '@/modules/translations'

type Props = {
	message: Message
	ratingValue?: number | null
	ratingText?: string | null
}

let { message, ratingValue, ratingText }: Props = $props()

const messageTarget: RatingTarget | null | undefined =
	message.content.type === MessageContentType.RateForm ? message.content?.data?.target : RatingTarget.Agent
const handleRateButtonClick = () => {
	openChatRatingDrawer(message.id)
}
let isAiRating = $derived($suggestedRating === WsRatingTarget.Ai || messageTarget === RatingTarget.Ai)
let shouldRenderRateButton = $derived(!ratingValue && !ratingText)

let ratingInfo: ChatRatingInfo | undefined = $derived(chatRatingInfoMap[ratingValue ?? 0])
</script>

{#if shouldRenderRateButton}
	<div class="flex-center w-full">
		<Button
			testId={isAiRating ? testIds.chatRatingButtonAi : testIds.chatRatingButtonAgent}
			variant="outline"
			onClick={handleRateButtonClick}
			>⭐️ {isAiRating ? $t('rating.button.rate.ai') : $t('rating.button.rate.agent')}</Button
		>
	</div>
{:else}
	<div class="flex-center flex-col w-full px-4 pt-6 pb-4 bg-slate-100 text-xs text-slate-800 rounded-3xl">
		<div class="mb-4 text-sm font-semibold text-center">
			{isAiRating ? $t('rating.wasItHelpful.ai') : $t('rating.wasItHelpful.agent')}
		</div>
		{#if ratingInfo}
			<div class="mb-4 flex flex-row space-x-5">
				{#each ratingInfoArray as r (r.value)}
					<div
						class={[
							'mx-2 text-lg opacity-10 w-60px h-60px rounded-full shadow-lg',
							r.value === ratingInfo.value && 'opacity-100',
						]}
					>
						<img src={getChatRatingImageUrl(r.name)} alt={r.name} />
					</div>
				{/each}
			</div>
			<div class="text-slate-500">{$t(ratingInfo.text)}</div>
		{/if}
		<div class="mt-6">
			{#if ratingText}
				<div class="p-4 bg-white rounded-3xl whitespace-pre-wrap break-all">
					{ratingText}
				</div>
			{:else}
				<Button testId={testIds.chatRatingFeedbackButton} variant="outline" onClick={handleRateButtonClick}
					>✍️ {$t('agentRating.all.placeholder')}</Button
				>
			{/if}
		</div>
	</div>
{/if}
